import styled from 'styled-components';

interface InputLengthProps {
  currentLength: number;
  maxLength: number;
}
export const InputLength = ({ currentLength, maxLength }: InputLengthProps) => {
  return (
    <div>
      <CurrentLength>{currentLength}</CurrentLength>
      <MaxLength>/{maxLength}</MaxLength>
    </div>
  );
};

const CurrentLength = styled.span`
  font-family: Pretendard Variable;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: #9170f2;
`;

const MaxLength = styled.span`
  font-family: Pretendard Variable;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: #8e899f;
`;
